import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import useSearchFiltering from 'dpl/search_result_filters/hooks/useSearchFiltering';

export default function ResultsTypeSelector({ className, locked }) {
  const { resultsType, setResultsType } = useSearchFiltering();

  return (
    <div
      className={classnames(
        'ResultsTypeSelector overflow-hidden fw-medium font-16-mobile',
        className
      )}
    >
      <div className="flex gap-20">
        <button
          type="button"
          onClick={() => setResultsType(RESULTS_TYPES.BREEDERS)}
          className={classnames('ResultsTypeBreeders search-tab', {
            'bb selected-tab-underline': resultsType === RESULTS_TYPES.BREEDERS,
            tertiary: resultsType !== RESULTS_TYPES.BREEDERS
          })}
          disabled={locked}
        >
          Breeders
        </button>
        <button
          type="button"
          onClick={() => setResultsType(RESULTS_TYPES.PUPPIES)}
          className={classnames('ResultsTypePuppies search-tab', {
            'bb selected-tab-underline': resultsType === RESULTS_TYPES.PUPPIES,
            tertiary: resultsType !== RESULTS_TYPES.PUPPIES
          })}
          disabled={locked}
        >
          Puppies
        </button>
      </div>
    </div>
  );
}

ResultsTypeSelector.propTypes = {
  className: PropTypes.string,
  locked: PropTypes.bool
};

ResultsTypeSelector.defaultProps = {
  className: null,
  locked: false
};
